<template>
  <div class="home" id="home">
    <div style="z-index: 2; position: relative">
      <transition name="slideFade">
        <el-card
          class="box-card box-card_potion"
          v-if="isShow"
          transiton="slideFade"
        >
          <div slot="header" class="clearfix">
            <div class="display flex">
              <h1 class="huihuaLeft fontHH" style="margin: 0 0 0 8px">
                会话列表
              </h1>
              <el-button
                style="
                  align-self: flex-start;
                  margin: 10px 10px 0 0;
                  color: #000;
                  font-size: 28px;
                "
                type="text"
                @click="recover"
                icon="el-icon-close"
              >
              </el-button>
            </div>
            <div style="width: 280px; margin: 10px 0 10px 20px；">
              <el-input
                style="margin-bottom: 10px；"
                placeholder="搜索"
                prefix-icon="el-icon-search"
                v-model="query"
                @change="GetModelDiscuss"
                clearable
              >
              </el-input>
              <div class="display" style="margin-top: 10px">
                <el-button size="small" type="warning" @click="HideSession">{{
                  showHide ? "隐藏完成项" : "显示全部"
                }}</el-button>
                <el-button
                  size="small"
                  @click="dialogVisibleOpen"
                  type="primary"
                  >发起会话</el-button
                >
              </div>
            </div>
          </div>
          <div class="BottomContent">
            <el-card
              class="box-card"
              v-for="conversation in conversaTionlist"
              :key="conversation.zwmd01"
              style="margin: 8px"
            >
              <div class="BtomCon_Card">
                <i
                  v-if="conversation.zwmd05 == $store.state.uid"
                  @click="deleteSession(conversation.zwmd01)"
                  style="color: red; fontsize: 20px"
                  class="el-icon-delete delete"
                ></i>
                <div class="huihuaLeft">
                  <div>会话名称：{{ conversation.zwmd03 }}</div>
                  <div>发起人：{{ conversation.zwmd05N }}</div>
                  <div>
                    @<span
                      v-for="uerInfo in conversation.LinkUser"
                      :key="uerInfo.user01"
                      >{{ uerInfo.user04 }}
                    </span>
                  </div>
                  <div>{{ conversation.zwmd04 }}</div>
                </div>
                <div class="huihuaLeft" style="text-align: center">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="open(conversation)"
                    v-if="
                      conversation.zwmd06 == 0 &&
                      conversation.zwmd05 == $store.state.uid
                    "
                    >确认验收</el-button
                  >
                  <div>{{ conversation.showTime }}</div>
                  <div>
                    <el-badge :value="conversation.ContentSum"></el-badge>
                  </div>
                  <el-button
                    :type="conversation.zwmd06 == 0 ? 'primary' : 'success'"
                    size="mini"
                    @click="openConversation(conversation)"
                    >{{
                      conversation.zwmd06 == 0 ? "进行中" : "已解决"
                    }}</el-button
                  >
                </div>
              </div>
            </el-card>
          </div>
        </el-card>
      </transition>
      <!-- 会话详细内容 -->
      <el-card class="box-card box-card_potion" v-if="conversationShow">
        <div slot="header" class="clearfix">
          <div class="display" style="width: 300px">
            <div class="huihuaLeft" style="margin: 10px 0 5px 8px">
              <h1 style="font-size: 16px; color: #169bd8">
                会话名称：{{ TopInformation.zwmd03 }}
              </h1>
              <div>发起人：{{ TopInformation.zwmd05N }}</div>
              <div>
                @<span
                  v-for="uerInfomation in TopInformation.LinkUser"
                  :key="uerInfomation.user01"
                  >{{ uerInfomation.user04 }}
                </span>
              </div>
              <div>{{ TopInformation.zwmd04 }}</div>
            </div>

            <el-button
              v-if="
                TopInformation.zwmd06 == 0 &&
                TopInformation.zwmd05 == $store.state.uid
              "
              @click="UpdateModelShow"
              style="align-self: flex-start; margin: 10px 10px 0 0"
              type="warning"
              size="mini"
              >编辑</el-button
            ><el-button
              style="
                align-self: flex-start;
                margin-left: 10px;
                color: #000;
                font-size: 28px;
              "
              type="text"
              icon="el-icon-close"
              @click="downConversation"
            >
            </el-button>
          </div>
          <div class="centert">
            <el-card
              style="margin: 10px"
              v-for="information in converInformationList"
              :key="information.zwdc01"
            >
              <div class="display" style="margin-top: 5px">
                <div>
                  <img
                    :src="$store.state.baseUrl + information.user13"
                    style="width: 20px; height: 20px"
                  />
                  <span>{{ information.user04 }}</span>
                </div>
                <div style="margin-right: 30px">{{ information.zwdc06 }}</div>
              </div>
              <div style="margin: 10px">
                <div v-html="information.zwdc03">{{ information.zwdc03 }}</div>
              </div>
              <div
                v-for="inforContent in information.viewList"
                :key="inforContent.zwmv01"
              >
                <div class="demo-image">
                  <div
                    style="
                margin:5px
                display: flex;
                flex-direction: column;
              "
                  >
                    <el-button @click="viewPoint(inforContent)" type="text">
                      {{ inforContent.zwmv03 }}
                    </el-button>
                    <img
                      :src="$store.state.baseUrl + inforContent.zwmv09"
                      style="width: 100%; height: 120px"
                    />
                  </div>
                </div>
              </div>
            </el-card>
          </div>
          <div class="bottom" v-if="solveProblem">
            <el-card>
              <div
                class="display"
                style="padding: 5px; height: 50px; line-height: 50px"
              >
                <el-input
                  @keydown.enter.native="sendFont"
                  v-model="fontContent"
                  placeholder="请输入文字"
                  type="text"
                  style="width: 55%"
                ></el-input>
                <div class="display" style="align-items: center; width: 40%">
                  <el-button type="mini" @click="openHighDialogVisible"
                    >高级</el-button
                  >
                  <el-button type="mini" @click="sendFont">发送</el-button>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </el-card>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      title="编辑人人员及标题"
      :visible.sync="UpdateModel"
      width="20%"
      center
    >
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="标题">
          <el-input v-model="SessionTitle"></el-input>
        </el-form-item>

        <el-form-item label="人员">
          <el-select v-model="userids" multiple placeholder="请选择">
            <el-option
              v-for="item in userList"
              :key="item.user01"
              :label="item.user04"
              :value="item.user01"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="UpdateModelDiscuss"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑会话内容 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑会话内容"
      :visible.sync="dialogVisible"
      width="60%"
      center
    >
      <div>
        <div
          class="display"
          style="width: 60%; height: 40px; line-height: 40px"
        >
          <span style="width: 100px">会话名称：</span>
          <el-input v-model="title" style="margin-bottom: 10px" clearable>
          </el-input>
        </div>
        <div
          class="display"
          style="width: 30%; height: 40px; line-height: 40px; margin-top: 20px"
        >
          <span style="width: 100px">相关人员：</span>
          <el-select v-model="userids" multiple placeholder="请选择">
            <el-option
              v-for="item in userList"
              :key="item.user01"
              :label="item.user04"
              :value="item.user01"
            >
            </el-option>
          </el-select>
        </div>
        <!-- 富文本框 -->
        <div style="margin-top: 20px">
          <ckediter4 v-model="TxtContent" ref="ck"></ckediter4>
        </div>
        <div
          class="display"
          style="width: 28%; height: 40px; line-height: 40px; margin-top: 20px"
        >
          <span style="width: 100px">选择模型：</span>
          <template>
            <el-select filterable v-model="modelId" placeholder="请选择">
              <el-option
                @click.native="choseOption(item)"
                v-for="item in optionsModel"
                :key="item.zwwp04"
                :label="item.zwwp03"
                :value="item.zwwp04"
              >
              </el-option>
            </el-select>
          </template>
        </div>
        <div style="width: 90%; line-height: 40px; margin-top: 20px">
          <span style="width: 100px">选择视点：</span>
          <div class="demo-image display" style="flex-wrap: wrap">
            <el-checkbox-group v-model="viewids">
              <el-checkbox
                v-for="item in chooseViewList"
                :label="item.zwmv01"
                :key="item.zwmv01"
              >
                <div
                  style="
                    width: 100px;
                    height: 120px;
                    display: flex;
                    flex-direction: column;
                    text-align: center;
                  "
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    :src="$store.state.baseUrl + item.zwmv09"
                  ></el-image>
                  <span style="">{{ item.zwmv03 }}</span>
                </div>
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="">
        <el-button type="danger" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="dialogVisibleSubmit">发送</el-button>
      </span>
    </el-dialog>
    <!-- 高级 -->
    <el-dialog
      :close-on-click-modal="false"
      title="编辑会话内容"
      :visible.sync="highDialogVisible"
      width="60%"
    >
      <div style="margin-top: 20px">
        <ckediter4 v-model="zjwj_discusscontent.zwdc03" ref="ck"></ckediter4>
      </div>
      <div
        class="display"
        style="width: 28%; height: 40px; line-height: 40px; margin-top: 20px"
      >
        <span style="width: 100px">选择模型：</span>
        <template>
          <el-select v-model="highModelId" placeholder="请选择">
            <el-option
              @click.native="ModelChange(item)"
              v-for="item in highModel"
              :key="item.zwwp04"
              :label="item.zwwp03"
              :value="item.zwwp04"
            >
            </el-option>
          </el-select>
        </template>
      </div>
      <div style="width: 90%; line-height: 40px; margin-top: 20px">
        <span style="width: 100px">选择视点：</span>
        <div class="demo-image display" style="flex-wrap: wrap">
          <el-checkbox-group v-model="highViewids">
            <el-checkbox
              v-for="item in highChooseViewList"
              :label="item.zwmv01"
              :key="item.zwmv01"
            >
              <div
                style="
                  width: 100px;
                  height: 120px;
                  display: flex;
                  flex-direction: column;
                  text-align: center;
                "
              >
                <el-image
                  style="width: 100px; height: 100px"
                  :src="$store.state.baseUrl + item.zwmv09"
                ></el-image>
                <span style="">{{ item.zwmv03 }}</span>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" style="">
        <el-button type="danger" @click="highDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="sendHighDialogVisible"
          >发送</el-button
        >
      </span>
    </el-dialog>

    <div id="left1">
      <div id="drag" style="left: 400px">
        <div class="Yuan" @click="testShowBtn">
          <span></span>
          <span></span>
        </div>
        <div class="Yuan-title">
          <div class="YuanTitleDrag"></div>
          <div class="zTreeDiv">
            <ul id="modelSessionTree" class="ztree"></ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 模型展示 -->
    <div v-show="!modelDB">
      <el-select
        style="position: absolute; top: 10px; right: 550px; z-index: 2"
        @change="changePlan"
        v-model="planId"
        filterable
        placeholder="请选择计划"
      >
        <el-option
          v-for="item in planList"
          :key="item.zwpp01"
          :label="item.zwpp03"
          :value="item.zwpp01"
        >
        </el-option>
      </el-select>
      <el-select
        style="position: absolute; top: 10px; right: 300px; z-index: 2"
        @change="changeUser"
        v-model="userId"
        filterable
        placeholder="请选择人员"
        clearable
      >
        <el-option
          v-for="item in userlist"
          :key="item.user01"
          :label="item.user04"
          :value="item.user01"
        >
        </el-option>
      </el-select>
      <el-button
        type="danger"
        size="mini"
        style="position: absolute; top: 10px; right: 0px; z-index: 2"
        v-show="modelLoad"
        @click="viewpointSave"
        >视点保存</el-button
      >
      <el-button
        type="danger"
        size="mini"
        v-show="modelLoad"
        style="position: absolute; right: 100px; top: 10px; z-index: 2"
        @click="pengzhuang"
        >模型碰撞</el-button
      >
      <el-button
        type="danger"
        size="mini"
        v-show="modelLoad"
        style="position: absolute; right: 200px; top: 10px; z-index: 2"
        @click="modelDuibi(1)"
      >
        模型对比
      </el-button>
      <el-button
        type="danger"
        size="mini"
        v-show="viewPointBtn"
        style="position: absolute; right: 200px; top: 10px; z-index: 2"
        @click="ExitViewPont()"
      >
        退出视点
      </el-button>
      <div id="MyViewerDiv" v-if="modelShow"></div>
      <canvas id="snapshot" hidden></canvas>
      <div class="crashCheck_box" id="crashCheckDiv">
        <div class="box_title">碰撞检查</div>
        <div class="btnClose" onclick="CrashCheck.close()">×</div>
        <div class="box_content">
          <div class="tab_title">
            <ul id="crashCheck_tabs" class="clearfix">
              <li
                class="current"
                style="width: 33%"
                onclick="CrashCheck.select(this)"
              >
                <a href="#" title="选择构件">选择构件</a>
              </li>
              <li style="width: 33%" onclick="CrashCheck.select(this)">
                <a href="#" title="碰撞结果">碰撞结果</a>
              </li>
              <li
                style="width: 33%"
                @click="GetCrashCheck"
                onclick="CrashCheck.select(this)"
              >
                <a href="#" title="碰撞结果">碰撞报告</a>
              </li>
            </ul>
          </div>
          <div id="menu_crashCheck_content_box">
            <div id="crashCheck_tab1" class="menu_table dis-bok">
              <div class="box">
                <div class="tree">
                  <ul id="crashCheck_tree1" class="ztree"></ul>
                </div>
                <el-button
                  style="width: 94%; margin-left: 5%"
                  size="small"
                  type="primary"
                  onclick="CrashCheck.export('crashCheck_tree1')"
                >
                  导入目前选择构件
                </el-button>
              </div>
              <div class="box">
                <div class="tree">
                  <ul id="crashCheck_tree2" class="ztree"></ul>
                </div>
                <el-button
                  style="width: 94%; margin-left: 5%"
                  size="small"
                  type="primary"
                  onclick="CrashCheck.export('crashCheck_tree2')"
                  >导入目前选择构件</el-button
                >
              </div>
              <el-button
                style="width: 94%; margin-left: 3%"
                size="small"
                type="primary"
                onclick="CrashCheck.todo()"
                >进行碰撞</el-button
              >
              <!-- <el-upload
                style="width: 100%; margin-top: 4px"
                class="upload-demo"
                :action="actionS"
                :headers="importHeaders"
                :data="uploadData"
                :before-upload="beforeUpload"
                :on-success="uploadSuccess"
                v-loading="uploadLoading"
                accept=".xml"
              >
                <el-button style="width: 94%" size="small" type="warning"
                  >上传碰撞报告</el-button
                >
              </el-upload> -->
            </div>
            <div id="crashCheck_tab2" class="menu_table dis-none">
              <div class="tree" style="height: 94%">
                <ul
                  id="crashCheck_resultTree"
                  class="ztree"
                  style="height: 90%"
                ></ul>
                <div id="rMenu_crashCheck" class="rMenu pos-fixed">
                  <ul id="rShowMenu_crashCheck">
                    <li
                      id="cc_m_del"
                      class="dis-lis-item"
                      onclick="CrashCheck.removeTreeNode()"
                    >
                      删除
                    </li>
                  </ul>
                </div>
              </div>
              <el-button
                style="width: 94%; margin-left: 5%"
                size="small"
                type="primary"
                @click="AddCrashCheckOpen"
              >
                保存
              </el-button>
            </div>
            <div id="crashCheck_tab3" class="menu_table dis-none">
              <div class="tree">
                <ul
                  id="crashCheck_baoGaoTree"
                  class="ztree"
                  style="height: 90%"
                ></ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="div_viewpoint"
        class="m-right-sidebar"
        style="right: 10%; height: 670px; top: 10%; display: none"
      >
        <h2 class="sdbcName">视点保存</h2>
        <div
          class="btnClose close_bt_p"
          onclick="ZJWJViewPoint.hiddenViewPoint();"
        >
          ×
        </div>
        <div class="body_viewpoint">
          <div
            id="viewpointUser"
            style="width: 100%; max-height: 10%; overflow: auto"
          ></div>
          <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
        </div>
        <div class="w-h-bg-cor">
          <el-button
            type="primary"
            id="vp-btn-mark"
            data-placement="bottom"
            data-toggle="tooltip"
            title="涂鸦"
            size="small"
            onclick="ZJWJViewPoint.showMarkTool()"
            >涂鸦</el-button
          >

          <el-button
            type="primary"
            id="vp-btn-save"
            data-placement="bottom"
            data-toggle="tooltip"
            size="small"
            title="保存"
            onclick="ZJWJViewPoint.onSaveLayer()"
            >保存</el-button
          >
          <el-button
            type="primary"
            id="vp-btn-save"
            data-placement="bottom"
            data-toggle="tooltip"
            size="small"
            title="发起会话"
            @click="fqtest"
            >发起会话</el-button
          >
        </div>
        <div id="rMenu_viewpoint" class="rMenu pos-fixed">
          <ul id="rShowMenu_viewpoint">
            <li
              id="vp_m_add"
              class="dis-lis-item"
              onclick="ZJWJViewPoint.addTreeNode()"
            >
              新建视点目录
            </li>
            <li
              id="vp_m_del"
              class="dis-lis-item"
              onclick="ZJWJViewPoint.removeTreeNode()"
            >
              删除
            </li>
            <li
              id="vp_m_ren"
              class="dis-lis-item"
              onclick="ZJWJViewPoint.renameTreeNode()"
            >
              重命名
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 这里是模型对比 -->
    <div class="ModelCompare" v-show="modelDB">
      <el-button
        type="danger"
        size="mini"
        style="position: absolute; right: 0px; z-index: 2"
        @click="modelDuibi(2)"
      >
        关闭
      </el-button>
      <div id="model1" class="model"></div>
      <div class="myBorder">
        <el-button
          @click="ModelCompare"
          class="myborder-el-button"
          title="比对"
          icon="el-icon-s-help"
          circle
        ></el-button>
        <div class="divs">
          <div title="删除">删除</div>
          <div title="增加">增加</div>
          <div title="变更前">变更前</div>
          <div title="变更后">变更后</div>
        </div>
      </div>
      <div id="model2" class="model model3"></div>
      <el-select class="modelListOne" v-model="model1" placeholder="请选择">
        <el-option
          v-for="item in modelList"
          :key="item.zwpm01"
          :label="item.zwpm03"
          :value="item.zwpm01"
          @click.native="model1Change(item)"
        ></el-option>
      </el-select>
      <el-select class="modelListTwo" v-model="model2" placeholder="请选择">
        <el-option
          v-for="item in modelList"
          @click.native="model2Change(item)"
          :key="item.zwpm01"
          :label="item.zwpm03"
          :value="item.zwpm01"
        ></el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import ckediter4 from "@/components/ck.vue";
import {
  GetWorkPlane,
  GetWorkPlanModel,
  AddDiscussContent,
  AddModelDiscuss,
  GetAuditUserList2,
  GetZjwjViewPoint,
  GetModelDiscuss,
  GetDiscussContent,
  FinishDiscuss,
  GetProjectPlan,
  GetPlanUploader,
  DelModelDiscuss,
  UpdateModelDiscuss,
} from "@/setAxios";
import _ from "lodash";
export default {
  name: "viewModel",
  components: { ckediter4 },
  data() {
    return {
      userList: [],
      //模型视点
      chooseViewList: [],
      viewids: [],
      modelId: "",
      optionsModel: [],
      title: "",
      TxtContent: "",
      userids: [],
      isShow: true,
      conversationShow: false,
      dialogVisible: false, // 内容
      highDialogVisible: false, //高级
      fontContent: "",
      optionsUser: [],
      value: [],
      conversaTionlist: [],
      uerInfoList: [],
      //会话详细内容 列表
      converInformationList: [],
      //会话详细内容数据
      TopInformation: {},
      //搜索
      query: "",
      //会话列表type
      type: "",
      showHide: true,
      //详细内容id
      contentId: "",
      //高级 模型视点
      highModel: [],
      highModelId: "",
      highViewids: [],
      highChooseViewList: [],
      zjwj_discusscontent: {
        zwdc01: "",
        zwdc02: "",
        zwdc03: "",
        zwdc05: localStorage.id,
        zwdc06: "",
      },
      solveProblem: true,
      //--------
      modelList: [],
      modelLoad: false,
      modelDB: false,
      model1: "",
      model2: "",
      model1Nanme: "",
      model1Nanme: "",
      model1Path: "",
      model2Path: "",
      loading: null,
      planId: "",
      userId: "",
      planList: [],
      userlist: [],
      planId2: "",
      userId2: "",
      planList2: [],
      userlist2: [],
      modelShow: true,
      viewPointBtn: false,
      UpdateModel: false,
      SessionTitle: "",
      SessionId: "",
    };
  },
  methods: {
    async UpdateModelDiscuss() {
      let params = {
        id: this.SessionId,
        title: this.SessionTitle,
        uids: this.userids,
      };
      let res = await UpdateModelDiscuss(params);
      if (res.Code) {
        this.$message({
          type: "success",
          message: "修改成功",
        });
        this.conversationShow = false;
        this.UpdateModel = false;
        this.GetModelDiscuss();
      }
    },
    async UpdateModelShow() {
      this.userids = [];
      this.TopInformation.LinkUser.forEach((ele) => {
        this.userids.push(ele.user01);
      });
      this.SessionTitle = this.TopInformation.zwmd03;
      this.SessionId = this.TopInformation.zwmd01;
      let params = {
        xid: localStorage.xid,
        qid: localStorage.pid,
        ids: localStorage.id,
      };
      let res = await GetAuditUserList2(params);
      this.userList = res.Data;
      this.UpdateModel = true;
    },
    deleteSession(id) {
      this.$confirm("确认删除该会话吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelModelDiscuss({ id });
        if (res.Code) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.GetModelDiscuss();
        }
      });
    },
    //退出视点
    ExitViewPont() {
      NOP_VIEWER.unloadExtension("Autodesk.Viewing.MarkupsCore");
      this.viewPointBtn = false;
    },
    //查看视点
    viewPoint(info) {
      this.modelShow = true;
      var data = {
        url: this.$store.state.baseUrl + info.zwpm04,
        modelId: info.zwmv02,
        cid: localStorage.pid,
        xid: localStorage.xid,
        type: "mxhh",
      };
      this.viewers(data, info);
    },
    changePlan() {
      this.userlist = [];
      this.userId = "";
      this.GetPlanUploader();
      this.GetWorkPlane();
    },
    changePlan2() {},
    changeUser() {
      this.GetWorkPlane();
    },
    changeUser2() {},
    fqtest() {
      let ids = "";
      this.reset();
      this.GetAuditUserList2(ids);
      this.dialogVisible = true;
      this.ZJWJViewPoint.getCheckBox().forEach((ele) => {
        let options = {
          zwmv01: ele.id,
          zwmv03: ele.name,
          zwmv09: ele.picture,
        };
        this.chooseViewList.push(options);
        this.viewids.push(ele.id);
      });
    },
    // ----模型
    viewpointSave() {
      ZJWJViewPoint.init(ZJWJ.viewer, ZJWJ.modelData, "checkbox");
    },
    pengzhuang() {
      CrashCheck.init(ZJWJ.viewer);
    },
    modelDuibi(type) {
      if (type === 1) {
        this.pinshengIsShow = false;
        this.modelDB = true;
      } else {
        this.pinshengIsShow = true;
        this.modelDB = false;
      }
    },
    AddCrashCheckOpen() {
      this.AddCrashCheckIsShow = true;
    },
    model1Change(val) {
      this.model1Nanme = val.zwpm03;
      this.model1Path = val.zwpm04;
      var path = this.$store.state.baseUrl + val.zwpm04;
      modelCompare.viewer1Load(path);
    },
    model2Change(val) {
      this.model2Nanme = val.zwpm03;
      this.model2Path = val.zwpm04;
      var path = this.$store.state.baseUrl + val.zwpm04;
      modelCompare.viewer2Load(path);
    },
    openFullScreen2() {
      this.loading = this.$loading({
        lock: true,
        text: "比对中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    ModelCompare() {
      if (this.model1 == "" || this.model2 == "") {
        this.$message({
          type: "warning",
          message: "请选择模型",
        });
      } else {
        if (!this.model1Path == this.model2Path) {
          this.$message({
            type: "warning",
            message: "请选择不同的模型进行比对",
          });
        } else if (modelCompare.viewer1IsLoad && modelCompare.viewer2IsLoad) {
          var length = modelCompare.getViewerLenth();
          var msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,是否进行比对？`;
          if (length[0] > 10000 || length[1] > 10000) {
            msg = `${this.model1Nanme}（模型1）共有<b>${length[0]}</b>个构件,${this.model2Nanme}（模型2）共有<b>${length[1]}</b>个构件,
             检测到模型较大，比对时间较长，是否进行比对？`;
          }
          this.$confirm(msg, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            dangerouslyUseHTMLString: true,
          }).then(() => {
            this.openFullScreen2();
            modelCompare.ModelCompare();
            var _Interval = setInterval(() => {
              if (modelCompare.compareComplete) {
                window.clearInterval(_Interval);
                this.loading.close();
                this.$message({
                  type: "success",
                  message: "比对完成",
                });
              }
            }, 1000);
          });
        } else {
          this.$message({
            type: "warning",
            message: "请等待模型加载完毕",
          });
        }
      }
    },
    async GetCrashCheck() {
      let params = {
        id: this.zjwj_crashcheck.zwcc02,
      };
      let res = await GetCrashCheck({ params });
      if (res.Data.length > 0) {
        CrashCheck.initCrashCheckBaoGao(res.Data);
      }
    },
    // ----
    //确认验收
    async open(value) {
      let params = {
        id: value.zwmd01,
      };
      let res = await FinishDiscuss(params);
      this.$confirm("是否确认验收?", "确认验收", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "验收成功!",
          });
          if (res.Code !== 0) {
            value.zwmd06 = res.Code;
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    recover() {
      this.isShow = false;
    },
    // --------
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "zwwp03",
          },
          simpleData: {
            enable: true,
            idKey: "zwwp01",
            pIdKey: "zwwp05",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init(
        $("#modelSessionTree"),
        setting,
        this.optionsUser
      );
      if (objs != null) {
        if (localStorage.treeNid) {
          var currentNode = objs.getNodeByParam("zwwp01", localStorage.treeNid);
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#modelSessionTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        _this.isShow = true;
        localStorage.setItem("treeNid", treeNode.zwwp01);
        let params = {
          id: treeNode.zwwp01,
        };
        GetWorkPlanModel({ params }).then((res) => {
          // mdoelShow
          var data = {
            url: _this.$store.state.baseUrl + res.Data.zwpm04,
            modelId: res.Data.zwpm01,
            cid: localStorage.pid,
            xid: localStorage.xid,
            type: "mxhh",
          };
          _this.viewers(data);
        });
        //接收会话列表
        _this.GetModelDiscuss();
      }
    },
    viewers(data, viewData) {
      this.modelLoad = false;
      this.viewPointBtn = false;
      this.$nextTick(() => {
        ZJWJ.LoadModel(data);
        var Interval = setInterval(() => {
          if (ZJWJ.modelLoad) {
            clearInterval(Interval);
            if (viewData) {
              if (viewData.zwmv04 == null) return;
              var json = viewData.zwmv08.replace(/'/g, '"');
              var jsonObject = JSON.parse(json);
              ZJWJ.viewer.restoreState(jsonObject);
              let markupM;
              setTimeout(() => {
                NOP_VIEWER.loadExtension("Autodesk.Viewing.MarkupsCore").then(
                  (markupsExt) => {
                    markupM = markupsExt;
                    markupM.enterEditMode();
                    var markup = viewData.zwmv04;
                    setTimeout(() => {
                      if (
                        markup &&
                        markup.replace(/(^\s*)|(\s*$)/g, "").length > 0
                      ) {
                        var markupList = markup.split("@#@");
                        if (markupList != null && markupList.length > 0) {
                          for (var i = 0, l = markupList.length; i < l; i++) {
                            var singleMarkup = markupList[i].split("@BIM@");
                            markupM.loadMarkups(
                              singleMarkup[1].replace(/'/g, '"'),
                              singleMarkup[0]
                            );
                          }
                          this.viewPointBtn = true;
                        }
                      }
                    }, 500);
                  }
                );
              }, 500);
            } else {
              this.modelLoad = true;
            }
          }
        }, 500);
      });
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    //-------
    reset() {
      this.userList = [];
      this.viewids = [];
      this.chooseViewList = [];
      this.optionsModel = [];
      this.userids = [];
      this.title = "";
      this.TxtContent = "";
      this.modelId = "";
    },
    //发起会话
    async dialogVisibleOpen() {
      let ids = "";
      this.reset();
      this.GetAuditUserList2(ids);
      this.dialogVisible = true;
    },
    //选择模型
    async choseOption(data) {
      let params = {
        id: data.zwwp04,
        uid: localStorage.id,
      };
      let res = await GetZjwjViewPoint({ params });
      let oldchooseViewList = _.cloneDeep(this.chooseViewList);
      this.chooseViewList = res.Data;
      this.viewids.forEach((ele) => {
        this.chooseViewList.push(
          ...oldchooseViewList.filter((item) => item.zwmv01 == ele)
        );
      });
      let hash = {};
      this.chooseViewList = this.chooseViewList.reduce((preVal, curVal) => {
        hash[curVal.zwmv01]
          ? ""
          : (hash[curVal.zwmv01] = true && preVal.push(curVal));
        return preVal;
      }, []);
    },
    //筛选人员
    async GetAuditUserList2(ids, data) {
      let params = {
        xid: localStorage.xid,
        qid: localStorage.pid,
        ids: localStorage.id,
      };
      let res = await GetAuditUserList2(params);
      this.userList = res.Data;
      params = {
        xid: localStorage.xid,
        type: 1,
        planId: this.planId,
        userId: this.userId,
      };
      res = await GetWorkPlane({ params });
      this.optionsModel = res.Data;
    },
    //会话完成
    async dialogVisibleSubmit() {
      this.TxtContent = this.$refs.ck.ckeditor.getData();
      let params = {
        xid: localStorage.xid,
        uids: this.userids.join(),
        content: this.TxtContent,
        viewids: this.viewids.join(),
        title: this.title,
        uid: localStorage.id,
      };
      let res = await AddModelDiscuss(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "发送成功",
        });
        this.GetModelDiscuss();
        this.dialogVisible = false;
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    //会话进行中
    async openConversation(value) {
      this.TopInformation = value;
      this.contentId = this.TopInformation.zwmd01;
      this.zjwj_discusscontent.zwdc02 = this.contentId;
      this.GetDiscussContent();
      this.conversationShow = true;
      if (this.TopInformation.zwmd06 == 1) {
        this.solveProblem = false;
      } else {
        this.solveProblem = true;
      }
    },
    //会话列表
    async GetModelDiscuss() {
      let params = {
        uid: localStorage.id,
        type: this.type,
        xid: localStorage.xid,
        searchword: this.query,
      };
      let res = await GetModelDiscuss({ params });
      this.conversaTionlist = res.Data;
    },
    //隐藏完成项
    HideSession() {
      if (this.showHide == true) {
        this.type = 0;
        this.GetModelDiscuss();
        this.showHide = false;
      } else {
        this.type = "";
        this.GetModelDiscuss();
        this.showHide = true;
      }
    },
    //获取会话内容列表
    async GetDiscussContent() {
      let params = {
        id: this.contentId,
      };
      let res = await GetDiscussContent({ params });
      this.converInformationList = res.Data;
    },
    downConversation() {
      this.conversationShow = false;
    },
    //高级中的模型视点
    async ModelChange(data) {
      let params = {
        id: data.zwwp04,
        uid: localStorage.id,
      };
      let res = await GetZjwjViewPoint({ params });
      let oldhighChooseViewList = _.cloneDeep(this.highChooseViewList);
      this.highChooseViewList = res.Data;
      this.highViewids.forEach((ele) => {
        this.highChooseViewList.push(
          ...oldhighChooseViewList.filter((item) => item.zwmv01 == ele)
        );
      });
      let hash = {};
      this.highChooseViewList = this.highChooseViewList.reduce(
        (preVal, curVal) => {
          hash[curVal.zwmv01]
            ? ""
            : (hash[curVal.zwmv01] = true && preVal.push(curVal));
          return preVal;
        },
        []
      );
    },
    resetHigh() {
      this.zjwj_discusscontent = {
        zwdc01: "",
        zwdc02: "",
        zwdc03: "",
        zwdc05: localStorage.id,
        zwdc06: "",
      };
      this.highModelId = "";
      this.highViewids = [];
      this.highChooseViewList = [];
      this.optionsModel = [];
      this.title = "";
      this.TxtContent = "";
    },
    //高级 发起会话
    async openHighDialogVisible() {
      this.resetHigh();
      this.highViewids = [];
      let params = {
        xid: localStorage.xid,
        type: 1,
        planId: this.planId,
        userId: this.userId,
      };
      let res = await GetWorkPlane({ params });
      this.highModel = res.Data;
      this.highDialogVisible = true;
    },
    //高级-会话完成
    async sendHighDialogVisible() {
      this.zjwj_discusscontent.zwdc02 = this.contentId;
      this.zjwj_discusscontent.zwdc03 = this.$refs.ck.ckeditor.getData();
      this.zjwj_discusscontent.zwdc06 = new Date();
      let params = {
        model: this.zjwj_discusscontent,
        viewids: this.highViewids.join(),
      };
      let res = await AddDiscussContent(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.GetDiscussContent();
        this.highDialogVisible = false;
        this.resetHigh();
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    //发送文字
    async sendFont() {
      this.zjwj_discusscontent.zwdc02 = this.contentId;
      this.zjwj_discusscontent.zwdc06 = new Date();
      this.zjwj_discusscontent.zwdc03 = this.fontContent;
      let params = {
        model: this.zjwj_discusscontent,
        viewids: this.highViewids.join(),
      };
      let res = await AddDiscussContent(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.GetDiscussContent();
        this.fontContent = "";
      } else {
        this.$message({
          type: "warning",
          message: res.Message,
        });
      }
    },
    async GetProjectPlan() {
      let params = {
        xid: localStorage.xid,
      };
      let res = await GetProjectPlan({ params });
      this.planList = res.Data;
      this.planId = res.Data[0].zwpp01;
      this.GetWorkPlane();
      this.GetPlanUploader();
    },
    async GetPlanUploader() {
      let params = {
        planId: this.planId,
      };
      let res = await GetPlanUploader({ params });
      this.userlist = res.Data;
    },
    GetWorkPlane() {
      let params = {
        xid: localStorage.xid,
        type: 1,
        planId: this.planId,
        userId: this.userId,
      };
      GetWorkPlane({ params }).then((res) => {
        this.optionsUser = this.modelList = res.Data;
        if (res.Data.length > 0) {
          this.modelShow = true;
          this.optionsUser.forEach((item) => {
            item.iconSkin = "pIcon01";
          });
          this.init();
        } else {
          this.modelShow = false;
        }
      });
    },
  },
  async created() {
    this.GetProjectPlan();
    window.list2dVM = this;
    this.$store.state.isClickProject = true;
    //传过来的this.$route.query.id
    let params = {
      uid: localStorage.id,
      type: this.type,
      xid: localStorage.xid,
      searchword: this.query,
    };
    let res = await GetModelDiscuss({ params });
    this.conversaTionlist = res.Data;
    if (!(this.$route.query.id == "undefined")) {
      this.contentId = this.$route.query.id;
      this.TopInformation = this.conversaTionlist.find((ele) => {
        return ele.zwmd01 == this.$route.query.id;
      });
      this.GetDiscussContent();
      this.conversationShow = true;
    }
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#crashCheckDiv");
  },
};
</script>
<style lang="less" scoped>
@import url("../../../public/Content/css/style.css");

.ModelCompare {
  width: 100%;
  height: 100vh;
  position: relative;
  .model {
    width: 50%;
    position: absolute;
    height: 100vh;
  }
  .model3 {
    left: 50%;
    width: 50%;
  }
  .myborder-el-button {
    position: absolute;
    top: 20%;
    left: -0.5rem;
    z-index: 99;
    background: #fff;
    color: #00bcd4;
    border: 0.25rem solid #00bcd4;
    font-size: 2rem;
  }

  .divs {
    width: 50px;
    font-size: 14px;
    text-align: center;
    position: absolute;
    height: 150px;
    padding-top: 50px;
    margin-top: 2rem;
    z-index: 9;
    background: #00bcd4;
    border-radius: 0 0 10px 10px;
    div {
      width: 88%;
      height: 22px;
      border-radius: 2px;
      margin: 10px auto;
      cursor: pointer;
      &:nth-child(1) {
        background-color: rgb(255, 0, 0);
      }
      &:nth-child(2) {
        background-color: rgb(0, 128, 0);
      }
      &:nth-child(3) {
        background-color: rgb(218, 165, 32);
        color: #000000;
      }
      &:nth-child(4) {
        color: #000000;
        background-color: rgb(255, 255, 0);
      }
    }
  }
  .myBorder {
    z-index: 999;
    position: absolute;
    left: 49%;
    height: 700px;
    background: #00bcd4;
    color: #fff;
    font-size: 18px;
    display: flex;
    align-items: center;
  }
  .modelListOne {
    position: absolute;
    z-index: 999;
    top: 2%;
    left: 2%;
  }
  .modelListTwo {
    position: absolute;
    z-index: 999;
    top: 2%;
    left: 52%;
  }
}
/deep/ .crashCheck_box {
  height: 700px;
  width: 300px;
  position: fixed;
  top: 10%;
  left: 60%;
  background: rgba(255, 255, 255);
  cursor: default;
}
.box_title {
  height: 3%;
}
.box_content {
  height: 97%;
}
.tab_title {
  height: 5%;
}
#menu_crashCheck_content_box .menu_table .box {
  width: 45%;
  margin-left: 2%;
  float: left;
  height: 85%;
  margin-bottom: 4px;
}
/deep/ .crashCheck_box {
  height: 700px;
  width: 300px;
  position: fixed;
  top: 10%;
  left: 60%;
  background: rgba(255, 255, 255);
}
/deep/ .el-upload {
  width: 100%;
}
#menu_crashCheck_content_box .menu_table .todo {
  line-height: 33px;
}
#menu_crashCheck_content_box .menu_table .box .export {
  line-height: 23px;
  margin: 0;
}
#menu_crashCheck_content_box {
  height: 92%;
}
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
}
#My2DViewerDiv {
  height: 95%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  height: 98%;
  position: relative;
}
.body_viewpoint {
  overflow: hidden;
  height: 90%;
  overflow-y: auto;
}
.body_viewpoint .treeDemo_viewpoint {
  width: 100%;
  height: 80%;
  border: none;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}
.search-input {
  width: 140px;
}
.back {
  background: #eee;
}
#middle1 {
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  border-left: 18px dashed transparent;
  margin-left: -9px;
  cursor: e-resize;
  display: none;
}

.reflex-layout.reflex-container {
  -ms-flex-pack: start;
  justify-content: flex-start;
  -ms-flex-align: stretch;
  align-items: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  height: 100%;
  width: 100%;
}
.reflex-layout.reflex-container.horizontal {
  -ms-flex-direction: column;
  flex-direction: column;
}
.reflex-layout.reflex-container.vertical {
  -ms-flex-direction: row;
  flex-direction: row;
}
.reflex-layout > .reflex-element {
  position: relative;
  overflow: auto;
  height: 100%;
  width: 100%;
}
.reflex-layout > .reflex-splitter {
  background-color: #eee;
  z-index: 100;
}
.reflex-layout > .reflex-splitter.active,
.reflex-layout > .reflex-splitter:hover {
  background-color: #c6c6c6;
  transition: all 1s ease;
}
.reflex-layout.horizontal > .reflex-splitter {
  border-bottom: 1px solid #c6c6c6;
  border-top: 1px solid #c6c6c6;
  cursor: row-resize;
  width: 100%;
  height: 2px;
}
.reflex-layout.horizontal .reflex-handle {
  cursor: row-resize;
}
.reflex-layout.horizontal > .reflex-splitter.active,
.reflex-layout.horizontal > .reflex-splitter:hover {
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.reflex-layout.vertical > .reflex-splitter {
  border-right: 1px solid #c6c6c6;
  border-left: 1px solid #c6c6c6;
  cursor: col-resize;
  height: 100%;
  width: 2px;
}
.reflex-layout.vertical .reflex-handle {
  cursor: col-resize;
}
.reflex-layout.vertical > .reflex-splitter.active,
.reflex-layout.vertical > .reflex-splitter:hover {
  border-right: 1px solid #eee;
  border-left: 1px solid #eee;
}
.reflex-layout > .reflex-splitter.reflex-thin {
  box-sizing: border-box;
  background: #000;
  background-clip: padding-box;
  opacity: 0.2;
  z-index: 100;
}
.reflex-layout
  > .reflex-splitter.reflex-thin.active
  .reflex-layout
  > .reflex-splitter.reflex-thin:hover {
  transition: all 1.5s ease;
  opacity: 0.5;
}
.reflex-layout.horizontal > .reflex-splitter.reflex-thin {
  border-bottom: 8px solid hsla(0, 0%, 100%, 0);
  border-top: 8px solid hsla(0, 0%, 100%, 0);
  height: 17px !important;
  cursor: row-resize;
  margin: -8px 0;
  width: 100%;
}
.reflex-layout.horizontal > .reflex-splitter.reflex-thin.active,
.reflex-layout.horizontal > .reflex-splitter.reflex-thin:hover {
  border-bottom: 8px solid #e4e4e4;
  border-top: 8px solid #e4e4e4;
}
.reflex-layout.vertical > .reflex-splitter.reflex-thin {
  border-right: 8px solid hsla(0, 0%, 100%, 0);
  border-left: 8px solid hsla(0, 0%, 100%, 0);
  width: 17px !important;
  cursor: col-resize;
  margin: 0 -8px;
  height: 100%;
}
.reflex-layout.vertical > .reflex-splitter.reflex-thin.active,
.reflex-layout.vertical > .reflex-splitter.reflex-thin:hover {
  border-right: 8px solid #e4e4e4;
  border-left: 8px solid #e4e4e4;
}

/deep/ .ztree li span.button.pIcon01_ico_open,
/deep/ .ztree li span.button.button.pIcon01_ico_close,
/deep/ .ztree li span.button.pIcon01_ico_docu {
  margin-right: 2px;
  background: url("../../assets/img/singleMode.png") no-repeat scroll 3px 1px
    transparent;
  vertical-align: top;
  background-size: 80%;
  *vertical-align: middle;
}
</style>
<style scoped lang = "less">
.box-card_potion {
  position: fixed;
  height: 95%;
  .BottomContent {
    position: absolute;
    left: 0;
    right: 0;
    top: 210px;
    bottom: 0px;
    overflow: auto;
    .BtomCon_Card {
      display: flex;
      justify-content: space-between;
      position: relative;
      .delete {
        position: absolute;
        top: -18px;
        right: -18px;
        cursor: pointer;
      }
      .huihuaLeft {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
    }
  }
}

.flex {
  width: 300px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}
.display {
  display: flex;
  justify-content: space-between;
}
.centert {
  position: absolute;
  left: 0;
  right: 0;
  top: 131px;
  bottom: 90px;
  overflow: auto;
}
.bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 90px;
}
.Btn {
  width: 55px;
  height: 30px;
  color: #fff;
  background: #4ab7ed;
  border-radius: 10px;
}
.fontHH {
  font-size: 30px;
  color: #169bd8;
}

/* 动画 */
.slideFade-enter {
  animation: slideFade-dialog-fade-in 0.5s ease;
}
.slideFade-leave {
  animation: slideFade-dialog-fade-out 0.5s ease forwards;
}
.slideFade-enter-active {
  animation: slideFade-dialog-fade-in 0.5s ease;
}
.slideFade-leave-active {
  animation: slideFade-dialog-fade-out 0.5s ease forwards;
}

/* @keyframes slideFade-dialog-fade-in {
  0% {
    transform: translate3d(-100%, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
} */
@keyframes slideFade-dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
    z-index: -1;
  }
}
/* 新增 */
#left1 {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  position: absolute;
}
.YuanTitleDrag {
  height: 20px;
  width: 100%;
  cursor: all-scroll;
}
.sdbcName {
  font-size: 20px;
  font-weight: 300;
  cursor: all-scroll;
}
.btnSearch {
  position: absolute;
  left: 0;
}
.pos-re-left4 {
  position: relative;
  left: 4px;
}
.clo1 {
  font-weight: 300;
  position: absolute;
  right: 0;
  color: #c3c3c3;
  font-size: 16px;
}
.w-h-bg-cor {
  width: 265px;
  height: 40px;
  /* background-color: #fff; */
}
#vp-btn-mark {
  margin: 1px 0 0 30px;
  display: inline-block;
}
#vp-btn-save {
  display: inline-block;
}
.dis-none {
  display: none;
}
.rMenu {
  visibility: hidden;
}
.pos-fixed {
  position: fixed;
}
.dis-lis-item {
  /* display: inline-block; */
}
.filter_box {
  cursor: default;
  display: none;
}
.dis-bok {
  display: block;
}
.mar-top3 {
  margin-top: 3%;
}
.crashCheck_box {
  cursor: default;
}
.gray {
  opacity: 0;
}
.height40p {
  height: 40px;
}
.width100 {
  width: 100%;
}
#vp-searchtxt {
  padding-left: 20px;
}
</style>
